import { render, staticRenderFns } from "./DocumentsData.vue?vue&type=template&id=0314634a"
import script from "./DocumentsData.vue?vue&type=script&lang=js"
export * from "./DocumentsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports